import apiClient from './client'

export const subscriptionsApi = {
  getPackages: async () => {
    const response = await apiClient.get('/packages')
    return response.data
  },

  createSubscription: async (data) => {
    const response = await apiClient.post('/subscriptions', data)
    return response.data
  },

  getUserSubscriptions: async () => {
    const response = await apiClient.get('/subscriptions/user')
    return response.data
  },

  getPaymentMethods: async () => {
    const response = await apiClient.get('/payment-methods')
    return response.data
  },
}

